<template>
  <section class="hero is-fullheight">
    <div class="imageSize is-hidden-mobile" :style="imageConnexionCss">

    </div>
    <div class="column is-2 is-offset-1 is-8-mobile is-offset-2-mobile verticalCenter">
      <div class="has-text-centered">
        <img src="@/assets/connexionPage/Logo_Affixe2.0.svg">
      </div>
      <br>
      <div class="has-text-centered">
      <span class="hero-title titreConnexion couleurFontDefault">
        Votre solution de gestion de la publicité extérieure
      </span>
      </div>
      <form  @submit.prevent="login({ site, email, password })">
        <b-field label="Site" class="couleurFontDefault labelInputConnexion">
          <input class="input" type="text"  v-model="site">
        </b-field>
        <b-field class="couleurFontDefault labelInputConnexion" label="Identifiant">
          <input class="input" type="text" name="username" v-model="email">
        </b-field>
        <b-field class="couleurFontDefault labelInputConnexion" label="Mot de passe">
          <input class="input" type="password" v-model="password">
        </b-field>
        <button class="button is-green btnConnexion" type="submit">Connexion</button>
      </form>
    </div>
    <div class="informationConnexion card cardColorOrange" v-if="afficherInfo">
      <b-notification has-icon aria-close-label="Close notification"
                      class="notificationHeaderBottom">
        <br>
        <div class="columns">
          <img src="@/assets/connexionPage/Edge.png" class="iconSize column is-1">
          <div class="column is-10">
            <b-field>
              <span class="subtitle">Affixe2.0 n'est pas compatible avec Edge</span>
            </b-field>
            <b-field class="greyTexte">
              Affixe2.0 est optimisé pour la version récente des navigateurs suivants :
            </b-field>
            <b-field class="has-text-centered">
              <a class="button is-dark is-medium"
                 @click="loadNewPage('https://www.google.com/chrome/')">
                <img src="@/assets/connexionPage/Logo_GoogleChrome.png">
                <span style="margin-left: 10px">Google Chrome</span>
              </a>
              <a class="button is-dark is-medium" style="margin-left: 10px"
                 @click="loadNewPage('https://www.mozilla.org/fr/firefox/new/')">
                <img src="@/assets/connexionPage/firefox-logo.png">
                <span style="margin-left: 10px">Mozilla Firefox</span>
              </a>
            </b-field>
            <b-field class="greyTexte">
              Nous vous conseillons de changer de navigateur pour profiter d'une expérience optimale
            </b-field>
            <br>
          </div>
        </div>
      </b-notification>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import suiviApi from '@/api/suiviApi';
import getImageConnexion from '@/api/imageConnexion';
import { AUTHORIZED_BROWSERS } from '@/configuration/browserConf';
import gestionErreur from '@/services/general/gestionErreur';
import { PAGE_DEFAULT } from '@/router/routerConf';
import { PARAMETRES_AFFIXE2, DOMAINE } from '@/configuration/paramsAffixe2';
import toastConfirmation from '@/services/general/toastConfirmation';
import backgroundLogin from '@/assets/connexionPage/Background-login-default.png';

const User = createNamespacedHelpers('user');
const Parametrages = createNamespacedHelpers('parametrage');
const bowser = require('bowser');

moment.locale('fr');

export default {
  name: 'connexion',
  data() {
    return {
      email: '',
      password: '',
      site: '',
      test: bowser.name,
      isIe: false,
      imageUrl: null,
      isFetchingImage: false,
    };
  },
  computed: {
    ...User.mapGetters({
      getCleApiGoogle: 'getCleApiGoogle',
      user: 'user',
    }),
    ...Parametrages.mapGetters({
      paramAffixe2: 'paramAffixe2',
      isAffixe2: 'affixe2',
    }),
    afficherInfo() {
      const browser = AUTHORIZED_BROWSERS.find((el) => {
        return bowser.name.toUpperCase() === el;
      });
      return browser === null || browser === undefined;
    },
    imageConnexionCss() {
      let url = backgroundLogin;
      if (this.isFetchingImage) url = '';
      else if (this.imageUrl) url = this.imageUrl;
      return { 'background-image': `url(${url})` };
    },
  },
  methods: {
    ...User.mapActions({
      actionsLogIn: 'logIn',
      actionLogOut: 'logOut',
      loadUsers: 'loadUsers',
    }),
    loadNewPage(url) {
      window.open(url);
    },
    async login() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.email = this.email.toLowerCase();
      this.site = this.site.toLowerCase();
      try {
        await this.actionsLogIn({
          email: this.email,
          password: this.password,
          site: this.site,
        });
        this.saveSession(this.email, this.site);
        if (this.isAffixe2 && this.user.domaine === DOMAINE) {
          await this.actionLogOut();
          toastConfirmation('Vous n\'êtes pas autorisé à vous connecter à affixe.', 'is-danger');
          return;
        }
        if (this.email.includes('@') && this.isAffixe2) {
          if (this.paramAffixe2[PARAMETRES_AFFIXE2.autoriserAuthentificationAffixe1.key] === 'warn') {
            toastConfirmation(`Merci de ne plus vous connecter avec une adresse mail (${this.email}) mais avec votre nom d'utilisateur Affixe2.`, 'is-warning');
          }
        }
        await this.loadUsers();
        this.$router.push(PAGE_DEFAULT);
      } catch (e) {
        gestionErreur('Erreur de connexion', e);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    saveSession(email, site) {
      suiviApi.post('/session', {
        email: email,
        site: site,
        date: moment().local().format('lll'),
      });
    },
    async loadImage() {
      this.isFetchingImage = true;
      try {
        // Le chargement de l'image ne doit pas être bloquant
        const response = await getImageConnexion();
        if (response.data && response.data.result) {
          this.imageUrl = response.data.result.chemin;
        }
      } finally {
        this.isFetchingImage = false;
      }
    },
  },
  mounted() {
    window.zE('webWidget', 'hide');
    this.loadImage();
  },
  destroyed() {
    window.zE('webWidget', 'show');
  },
};
</script>

<style lang="scss">
  .titreConnexion {
    margin-top : 4em;
    h1 {

      font-size : 2em;
      font-weight: bold;
    }
  }
  .verticalCenter {
    margin-top: auto;
    margin-bottom: auto
  }
  .imageSize {
    position: fixed;
    width: 67%;
    height: 100%;
    right: 0;
    background-size: cover;
    background-color: white;
    background-position-x: right;
  }
  .labelInputConnexion {
    font-weight: bold;
    padding-top: 1em;
  }
  .cardColorOrange {
    background-color: rgb(236,161,78)!important;
    width: 550px!important;
  }
  .btnConnexion {
    margin-top: 3em;
    margin-bottom: 2em;
    width:100%
  }
  .iconSize {
    height: 70px!important;
    width: 70px!important;
    margin-left: 10px;
  }
  .greyTexte{
    font-size: 0.9em;
    color: #ACB2BC;
  }
  .notificationHeaderBottom {
    margin-left: 6px;
    margin-top: 1px;
    margin-bottom: 1px;
    margin-right: 1px;
  }
  .informationConnexion{
    position: absolute;
    bottom : 70px;
    right: 70px;
    p{
      margin: 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/connexion/connexion.vue